<div class="partner-legal-container">
    <div class="partner-legal-content">
        <div class="partner-legal-header">
            <div class="legal-header-image">
                <img class="logo" [src]="'https:' + sponsorOnboardingCMSData?.legalDocIcon.fields.file.url" alt="legal-icon">
            </div>
            <div class="legal-header-details">
                <div class="header-title">
                    {{sponsorOnboardingCMSData?.legalDocLabel}}
                </div>
                <div class="header-desc">
                    {{sponsorOnboardingCMSData?.legalDocDesc}}
                </div>
            </div>
        </div>

        <div class="legal-field-container">
            <div class="checkbox-container">
                <div class="checkbox">
                    <app-custom-check-box [rounded]="false" [height]="26" [width]="26" [(isChecked)]="legalDetalis.enableTnC" (isCheckedChange)="valueChange($event, 'enableTnC')"></app-custom-check-box>
                </div>
                <div class="tnc-text">
                    <markdown id="tnc-content" class="text-here" [data]="sponsorOnboardingCMSData?.agreeTnCHelptext"></markdown>
                </div>
                
            </div>

            <div class="checkbox-container">
                <div class="checkbox">
                    <app-custom-check-box [rounded]="false" [height]="26" [width]="26" [(isChecked)]="legalDetalis.enablePrivacy" (isCheckedChange)="valueChange($event, 'enablePrivacy')"></app-custom-check-box>
                </div>
                <div class="tnc-text">
                    <markdown id="tnc-content" class="text-here" [data]="sponsorOnboardingCMSData?.agreePrivacyHelptext"></markdown>
                </div>
            </div>

            <div class="divider"></div>
        </div>
    </div>
</div>